import { connect } from 'react-redux';
import CardView from './card-view';
import { loadCardsForBulletinBoardAction, onLoadCourse, pinOrUnpinContentAction } from '../../reducers/course.reducers';

const mapStateToProps = state => ({
  config: state.authentication.config,
  bulletinBoard: state.courses.bulletinBoard,
  cards: state.courses.bulletinBoardCards,
});

const mapDispatchToProps = dispatch => ({
  loadCards: (boardId, sortFilterDto) => dispatch(loadCardsForBulletinBoardAction({ boardId, sortFilterDto })),
  loadCourse: course => dispatch(onLoadCourse(course)),
  pinOrUnpinContent: (bulletinBoardId, pinningDto) => dispatch(pinOrUnpinContentAction({ bulletinBoardId, pinningDto })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CardView);



// WEBPACK FOOTER //
// ./src/app/main/bulletin-board/card-view.container.js